<template>
    <div class="">

        <br /> <div style="text-align: right; font-weight: bold;"><span class="mandatory">* Mandatory</span></div><br />

        <div class="col-12 text-center">
            <div style="font-weight:bold; font-size: 12px; margin: 4px;" for="termsOptionsSelect">Choose Contract Template</div>
            <select id="termsOptionsSelect" class="form-select" v-model="selectedTemplateId" @change="updateTerms" style="width:fit-content; margin:16px auto;">
                <option v-for="option in TermsOptions" :key="option.Id" :value="option.Id">
                    {{ option.Tag }}
                </option>
            </select>
        </div>


        <div class="info mt-2" style="font-size:14px; font-weight:bold; text-align:center;">{{TermsInfo}}</div>

        <div class="col-12 mt-4">
            <transition-group name="terms" tag="div">
                <div class="form-check"
                     v-for="(item, originalIndex) in Terms"
                     :key="item.id"
                     style="margin-top:8px; background-color:white; border-radius:4px; padding:8px; display: flex; ">
                    <!-- Index label -->
                    <div style="margin-right: 8px; font-weight: bold; width: 20px; text-align: center; margin-top: 4px;" v-if="Terms.length > 1">
                        <span v-if="isChecked(item)">
                            {{ getCheckedIndex(originalIndex) }}.
                        </span>
                        <span v-else>&nbsp;</span> <!-- Render an empty placeholder -->
                    </div>


                    <div style="width: 100%;">
                        <label class="unselectable editable"
                               v-if="!item.customTerm"
                               v-html="item.value"
                               :id="'Editable_' + originalIndex"
                               :contenteditable="isChecked(item) ? 'true' : 'false'"
                               @input="updateTerm()"
                               unselectable="on"
                               @paste="cleanPaste($event, item)"
                               :style="isChecked(item) ? 'margin-bottom: 5px; width: 100%; padding: 4px;' : 'margin-bottom: 5px; width: 100%; padding: 4px; color:Var(--bs-gray-500);'">
                        </label>
                        <CustomTermWithAI v-else
                                          :id="'Editable_' + originalIndex"
                                          :initialData="item"
                                          :index="originalIndex"
                                          :editable="isChecked(item)"
                                          @showLoader="showLoader"
                                          @hideLoader="hideLoader" />

                        <div class="text-center" style="display:flex; width:100%; position:relative;" v-if="Terms.length > 1">
                            <div class="toggle-switch" style="margin: auto;">
                                <input type="checkbox"
                                       :id="'Terms_' + originalIndex"
                                       v-model="Contract.Terms"
                                       :value="item" />

                                <label :for="'Terms_' + originalIndex"
                                       class="toggle-label"
                                       style="justify-content:center;">
                                    <span class="toggle-indicator" style="width:16px;">Y</span>
                                    <span class="toggle-indicator" style="width:16px;">N</span>
                                </label>

                                <label :for="'Terms_' + originalIndex" style="cursor: pointer;">
                                    <span class="toggle-text" :style="isChecked(item) ? '' : 'color:Var(--bs-gray-500);'">Keep Clause</span>
                                </label>
                            </div>

                            <div class="mean"
                                 v-if="VideoUrls[originalIndex] && VideoUrls[originalIndex] != null && VideoUrls[originalIndex].length > 0"
                                 @click="showVideo(VideoUrls[originalIndex])">
                                <div class="relative thumbnail">
                                    <img :src="getThumbnail(VideoUrls[originalIndex])"
                                         class="object-cover rounded border w-full h-full hover:shadow-lg"
                                         alt="video thumbnail" />
                                    <div class="absolute inset-0 flex items-center justify-center text-white hover:text-blue-500 transition-opacity duration-300">
                                        <n-icon size="60">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M10 16.5l6-4.5l-6-4.5zM12 2C6.48 2 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8s8 3.59 8 8s-3.59 8-8 8z" fill="currentColor"></path>
                                            </svg>
                                        </n-icon>
                                    </div>
                                </div>
                            </div>
                            <div class="mean" v-else style="visibility:hidden;">
                                <span class="material-icons icon material-symbols-outlined">smart_display</span>
                            </div>
                        </div>
                    </div>


                </div>
                <div v-if="0 < termsForAttachments.length" class="form-check" style="margin-top:8px; background-color:white; border-radius:4px; padding:8px; display: flex; ">
                    <!-- Attachment Index label -->
                    <div style="margin-right: 8px; font-weight: bold; width: 20px; text-align: center; margin-top: 4px;" v-if="Terms.length > 1">
                        <span>
                            {{ getCheckedIndex(this.nextTermId) + 1}}.
                        </span>
                    </div>
                    <div style="width:100%;">
                        <div style="padding: 4px; position:relative;">
                            <p v-if="0 < this.termsForAttachments.length">{{termsForAttachments}}</p>
                        </div>
                    </div>
                </div>
                <div v-if="true" class="form-check" style="margin-top: 8px; background-color: white; border-radius: 4px; padding: 16px 8px 8px 8px;; display: flex; ">
                    <!-- Attachment Index label -->
                    <div style="width:100%;">
                        <div class="row attachment-box">
                            <div class="col-12" style="padding: 4px; position: relative; line-height: 16px;">
                                <p style="text-align: center;">Do you have any documents (optional) that you would like to attach to this agreement? If so, please upload below.<br /><sub>(Please attach only PDF or Image files)</sub></p>
                            </div>
                            <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3"
                                 v-show="isAttachmentVisble(attachmentIndex)"
                                 v-for="(attachment, attachmentIndex) in Attachments" :key="attachmentIndex">
                                <div class="schedule">
                                    <input type="text" v-model="attachment.title" placeholder="Document Title" class="form-control schedule-title" />
                                    <div class="schedule-upload-area" :class="{ DropBoxHighlight }" @click="triggerFileInput(attachmentIndex)"
                                         @drop.prevent="handleAttachemtFileUpload(attachmentIndex, $event)"
                                         @dragover.prevent="DropBoxHighlight = true"
                                         @dragleave="DropBoxHighlight = false">
                                        <div v-if="iconForAttachments(attachmentIndex, 0) == -1" class="txt">Drag and drop here<br /> or click to browse</div>
                                        <i v-if="iconForAttachments(attachmentIndex, 0) == 1" class="material-symbols-outlined material-icons icon pdf-icon"></i>
                                        <i v-if="iconForAttachments(attachmentIndex, 0) == 0" class="material-symbols-outlined material-icons icon image-icon"></i>
                                        <input type="file" :ref="'attFile' + attachmentIndex" accept="image/*, application/pdf" @change="handleAttachemtFileUpload(attachmentIndex, $event)" />
                                        <ol class="schedule-filelist" v-if="!attachment.isUploading">
                                            <li v-for="(file, fileIndex) in attachment.files" :key="file.fileId">
                                                <text class="schedule-filename">{{ file.name }}</text>
                                                <span class="schedule-option">
                                                    ({{formatBytes(file.size)}})
                                                    <i class="material-icons" v-if="'' == file.fileId" style="color:#dc9d45;">cloud_upload</i>
                                                    <i class="material-icons" v-if="'' != file.fileId" style="color:#d0c0c0;" @click="handleAttachemtFileRemove(attachmentIndex, fileIndex)">clear</i>
                                                </span>
                                            </li>
                                        </ol>
                                    </div>
                                    <div style="text-align:center; position:relative; font-size:14px;">
                                        <div> This attachment will be labelled <br>Schedule "{{String.fromCharCode(65 + attachmentIndex) }}"</div>
                                        <i class="material-icons trash" @click="handleAttachemtFileRemove(attachmentIndex, -1)">delete_forever</i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" style="margin: 10px 0px; text-align: center;">
                                <i v-if="isMobile && '1111' != DisplayAttachmentBox.join('')" class="material-icons attachment-plus" @click="setAttachmentVisble">add_circle</i>
                            </div>
                        </div>
                    </div>
                </div>

            </transition-group>

        </div>

        <!-- Video Modal -->
        <n-modal v-model:show="videoModalVisible" style="width: fit-content; max-height: 80vh; text-align:center; position:relative;" preset="card" size="large">
            <video ref="termVideoPlayer"
                   :src="videoSrc"
                   controls
                   style="max-width: 100%; max-height: 70vh; margin:auto;"
                   @ended="onVideoEnd"></video>
        </n-modal>

        <CustomPopup :visible="showPopup"
                     :icon="popupIcon"
                     :iconSrc="popupIconSrc"
                     :iconColor="iconColor"
                     :title="popupTitle"
                     :content="content"
                     :cancelText="cancelText"
                     :confirmText="confirmText"
                     :confirmButtonType="confirmButtonType"
                     :confirmAction="currentConfirmAction"
                     @cancel="onCancel" />

    </div>
</template>

<script>
    import { ref } from 'vue';
    import useContacts from "../composables/useContacts";

    const { saveAttachment, attachments } = useContacts();


    import CustomTermWithAI from './CustomTermWithAI.vue';

    import { fileUrl, imageUrl } from '../composables/http'
    import CustomPopup from '../components/modals/CustomPopup.vue';
import { c } from 'naive-ui';

    export default {
        components: {
            CustomTermWithAI, CustomPopup
        },
        props: {
            initialData: {
                type: Object,
                default: () => ({})
            },
            type: {
                type: Number,
                default: 1
            },
            hasTerms: {
                type: Boolean,
                default: false
            },
            TermsId: {
                type: String,
                default: '00000000-0000-0000-0000-000000000000'
            },
        },
        data() {
            return {
                Terms: [],
                TermsOptions: [],
                selectedTemplateId: '',
                Contract: {
                    Terms: []
                },
                TermsInfo: "Please review the terms of the default Client contract.  You may also freely edit or delete any term below to suit your needs.",
                VideoUrls: [],
                DefaultVideoUrls: [],

                videoModalVisible: false, // Controls modal visibility
                videoSrc: '',             // Holds the current video URL

                nextTermId: 1, // To generate unique IDs
 
                /////////////////
                isMobile: false,
                AttachmentTermsTitle: '',
                Attachments: attachments.value,
                DropBoxHighlight: false,
                DisplayAttachmentBox: [1, 0, 0, 0],

                 //Custom Popup
                showPopup: false,
                popupIcon: null, 
                popupIconSrc: '',
                iconColor: '',
                popupTitle: '',
                content: '',
                cancelText: '',
                confirmText: '',
                confirmButtonType: 'primary',
                currentConfirmAction: null,

                /////

                passedInData: [],
                IsTermChanged: false,
            }
        },
        mounted() {
            this.addAttachments();
 

            this.getTerms();

            this.checkDevice();
            window.addEventListener('resize', this.checkDevice);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkDevice);
        },
        computed: {
            termsForAttachments: function () {
                const c2C = (str) => {
                    return str.replace(/^\w/, c => c.toUpperCase());
                }

                const joinArray = (arr) => {
                    if (!arr || arr.length === 0) return "";
                    if (arr.length === 1) return arr[0];
                    return arr.slice(0, -1).join(", ") + " and " + arr.slice(-1);
                }

                let titles = [];
                this.Attachments.forEach((att, attIdx) => {
                    if (att.files.length > 0) {
                        titles.push(`Schedule "${String.fromCharCode(65 + attIdx)}" – ${att.title == '' ? "No Title" : c2C(att.title)}`);
                    }
                });

                if (titles.length > 0) {
                    return `Attached alongside this agreement in one document is the following Schedule, ${joinArray(titles)} `;
                } else {
                    return "";
                }
            },
            iconForAttachments () {
                return (attIdx, fileIdx) => {
                    let iconName = "";
                    if (attIdx > this.Attachments.length - 1 || attIdx < 0) { return -1; }
                    const att = this.Attachments[attIdx];
                    if (fileIdx > att.files.length - 1 || fileIdx < 0) { return -1; }
                    const fileType = att.files[fileIdx].type ?? att.files[fileIdx].name;
                    return fileType.endsWith("pdf") ? 1 : 0;
                }
            },
            isAttachmentVisble() {
                return (attIdx) => {
                    // All visble for none mobile screen
                    if (!this.isMobile) {
                        return true;
                    }
                   
                    if ((attIdx > this.Attachments.length - 1) || (attIdx < 0)) {
                        return (this.DisplayAttachmentBox[attIdx] == 1);
                    }

                    const att = this.Attachments[attIdx];
                    const file = att.files.find(x => x.fileId != '');
                    return ((file !== undefined) || (this.DisplayAttachmentBox[attIdx] == 1) || (att.title != ''));
                }
            }
        },

        methods: {
            checkDevice() {
                this.isMobile = window.innerWidth <= 768;
            },
            formatBytes(bytes) {
                if (1 > bytes) { return ''; }

                if (bytes < 1024 * 100) {
                    return `${(bytes / 1024).toFixed(0)} KB`;
                } else {
                    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
                }
            },
            showLoader(){
                this.$loader.show(null, 30);
            },
            hideLoader(){
                this.$loader.hide();
            },
            isChecked(term) {
                return this.Contract.Terms.some(existingTerm => existingTerm.id === term.id);
            },
            getCheckedIndex(originalIndex) {
                // Filter Terms to calculate the index of the checked item
                return (
                    this.Terms.slice(0, originalIndex + 1).filter((term) =>
                        this.Contract.Terms.some(existingTerm => existingTerm.id === term.id)
                    ).length
                );
            },
            getThumbnail(url) {
                const match = url.match(/([^/]+?)(?:\.\w+)?$/);
                return imageUrl(match ? match[1] : '', 120, 90);
            },
            showVideo(videoUrl) {
                this.videoSrc = videoUrl; // Set the video source
                this.videoModalVisible = true; // Show the modal

                this.$nextTick(() => {
                    // Automatically play the video once the modal is opened
                    this.$refs.termVideoPlayer.play();
                });
            },
            onVideoEnd() {
                // Optionally handle the event when the video ends
                console.log("Video has ended");
            },

            getTermsId() {
                return this.selectedTemplateId;
            },

            updateTerm() {
                if(!this.IsTermChanged){
                   this.$emit('term-updated'); 
                   this.IsTermChanged = true;
                }            
            },

            cleanPaste(event, item) {
                event.preventDefault();

                // Get the HTML content from clipboard
                const clipboardData = event.clipboardData || window.clipboardData;
                const htmlData = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

                //console.log("htmlData", htmlData);
                // Create a temporary DOM element to parse the HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = htmlData;

                // Clean unwanted styles recursively
                function sanitize(node) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const allowedTags = ['B', 'STRONG', 'P', 'BR', 'LI', 'UL', 'OL'];

                        // Disallow tags that are not in the allowed list
                        if (!allowedTags.includes(node.tagName)) {
                        const fragment = document.createDocumentFragment();
                        node.childNodes.forEach(child => {
                            const cleaned = sanitize(child);
                            if (cleaned) fragment.appendChild(cleaned);
                        });
                        return fragment;
                        }

                        // Create a new clean version of the node
                        const cleanNode = document.createElement(node.tagName);

                        node.childNodes.forEach(child => {
                        const cleaned = sanitize(child);
                        if (cleaned) cleanNode.appendChild(cleaned);
                        });

                        // 🧹 Check for empty tags: remove <p> that only contains whitespace or &nbsp;
                        if (
                        ['P', 'LI'].includes(cleanNode.tagName) &&
                        cleanNode.textContent.replace(/\u00A0/g, '').trim() === ''
                        ) {
                        return null; // Skip this node
                        }

                        return cleanNode;
                    } else if (node.nodeType === Node.TEXT_NODE) {
                        if (node.textContent.replace(/\u00A0/g, '').trim() === '') {
                            return null; 
                        }
                        return document.createTextNode(node.textContent);
                    }

                    return null;
                }

                /*
                function removeLeadingEmptyLines(container) {
                    while (container.firstChild) {
                        const first = container.firstChild;

                        // Remove <p> or <div> tags with only whitespace or &nbsp;
                        if (
                        first.nodeType === Node.ELEMENT_NODE &&
                        ['P', 'DIV'].includes(first.tagName) &&
                            first.textContent.replace(/\u00A0/g, '').trim() === ''
                        ) {
                        container.removeChild(first);
                        } else {
                        break; // Stop if first meaningful content is found
                        }
                    }
                }
                */

                const cleanContent = sanitize(tempDiv);

                //removeLeadingEmptyLines(cleanContent);

                for (let i = 0; i < cleanContent.childNodes.length; i++) {
                    const node = cleanContent.childNodes[i];
                    //console.log('node', node.nodeType, node.textContent);
                }

                // Insert cleaned content at the caret position
                const selection = window.getSelection();
                if (!selection.rangeCount) return;
                const range = selection.getRangeAt(0);
                range.deleteContents();

                const fragment = document.createDocumentFragment();
                Array.from(cleanContent.childNodes).forEach(node => fragment.appendChild(node));
                range.insertNode(fragment);

                // Move caret to the end
                range.collapse(false);
                selection.removeAllRanges();
                selection.addRange(range);
  
            },

            //collect all the data to check term changes, and update term template
            getCurrentTermsData() {
               
                var Terms = this.getCurrentTerms();
                var UserId = this.$core.data.UserInfo.Id;

                const selectedOption = this.TermsOptions.find(option => option.Id === this.selectedTemplateId);

                //how to compare 2 arrays: Terms and selectedOption.Terms
                if (selectedOption) {
                    if (selectedOption.Terms.length != Terms.length) {
                        this.IsTermChanged = true;
                    } else {
                        for (var i = 0; i < selectedOption.Terms.length; i++) {

                            let originalTerm = "";
                            if(selectedOption.Terms[i].value){
                                originalTerm = selectedOption.Terms[i].value.replace(/<p>/g, '').replace(/<\/p>/g, '');
                            }else{
                                originalTerm = selectedOption.Terms[i].replace(/<p>/g, '').replace(/<\/p>/g, '');
                            }
                            var newTerm = Terms[i].replace(/<p>/g, '').replace(/<\/p>/g, '');
                            if (originalTerm != newTerm) {
                                this.IsTermChanged = true;
                                //console.log("found Term Changed Original: " + i, originalTerm);
                                //console.log("found Term Changed Update: " + i, newTerm);
                                break;
                            }
                        }
                    }
                }

                //console.log("getCurrentTermsData selectedOption:", selectedOption);
                if(selectedOption.Id == '00000000-0000-0000-0000-000000000000'){
                    this.IsTermChanged = false;
                }
                var data = {
                    Id: this.selectedTemplateId,
                    Tag: selectedOption.Tag,
                    Terms: Terms,
                    UserId: UserId,
                    Type: selectedOption.Type,                
                    IsChanged: this.IsTermChanged
                }
                //console.log("getCurrentTermsData:", data);

                return data;
            },

            getCurrentTerms() {

                var elts = document.getElementsByClassName("editable");
                var newTerms = [];

                if(this.Terms.length == 1){
                    newTerms.push(elts[0].innerHTML);
                    //newTerms.push(this.Terms[0].value);
                    return newTerms;
                }

                for (var i = 0; i < elts.length; i++) {
                    if (document.getElementById("Terms_" + i).checked) {
                        if (elts[i].innerHTML.length > 0)
                            newTerms.push(elts[i].innerHTML);
                    }
                }
                return newTerms;
            },
            initData(data) {

                this.passedInData = data;
                //console.log("init TermsComponent", data);
                 //console.log("init TermsComponent", this.TermsId);

                

                var terms = [];
                data.forEach((item, idx) => {
                    terms.push({ id: idx + 1, value: item, customTerm: false });

                    this.nextTermId = idx + 1;
                });

                this.Terms = JSON.parse(JSON.stringify(terms));
                this.Contract.Terms = JSON.parse(JSON.stringify(terms));

                if(this.TermsId != null && this.TermsId != '00000000-0000-0000-0000-000000000000'){
                    let TermOptions = this.TermsOptions.find(option => option.Id === this.TermsId);
                    if(TermOptions){
                        TermOptions.Terms = JSON.parse(JSON.stringify(terms));
                    }
                }
             
                //console.log(this.Contract.Terms);
                this.VideoUrls = [];
            },
            initAttachments(data) {
                //console.log(`initAttachments`, data);
                this.Attachments = [];
                // only one file per Attatchment(4) for now
                this.addAttachments(); 

                if (data) {
                    data.forEach((att, idx) => {
                        
                        this.Attachments[idx] = {
                            id: att.Id,
                            title: att.Title,
                            files: (att.File == '' || att.File === null) ? [] : [{
                                name: att.FileName,
                                size: att.FileSize,
                                fileId: att.File
                            }]
                        };
                    });
                }
            },
            updateTerms() {

                // Update the Terms when a new template is selected
                const selectedOption = this.TermsOptions.find(option => option.Id === this.selectedTemplateId);

                if (selectedOption) {
                    this.Terms = []; // Clear terms to trigger re-render

                    this.VideoUrls = [];

                    var terms = [];

                    let _terms = selectedOption.Terms;
                    if(selectedOption.value){
                        _terms = selectedOption.value.Terms;
                    }

                   
                    if (this.selectedTemplateId == '00000000-0000-0000-0000-000000000000') {
                        this.VideoUrls = this.DefaultVideoUrls;
                        terms = _terms;

                        if (this.type == 0) {
                            this.TermsInfo = "Please review the terms of the default Sub-Contractor contract. You may also freely edit or delete any term below to suit your needs.";
                        } else {
                            this.TermsInfo = "Please review the terms of the default Client contract. You may also freely edit or delete any term below to suit your needs.";
                        }

                    } else {
                        _terms.forEach((item, idx) => {
                            
                            terms.push({ id: idx + 1, value: item.value?item.value:item, customTerm: false  });
                            this.nextTermId = idx + 1;
                        });

                        if (this.type == 0) {
                            this.TermsInfo = "Please review the terms of your Sub-Contractor contract. You may also freely edit or delete any term below to suit your needs.";
                        } else {
                            this.TermsInfo = "Please review the terms of your Client contract. You may also freely edit or delete any term below to suit your needs.";
                        }
                    }

                    //this.nextTermId = 1;

                    //console.log("update terms", _terms);
                    
                    if(terms.length == 1){
                        this.$emit("updateShowAddTerms", false);
                    }else{
                        this.$emit("updateShowAddTerms", true);
                    }

                    setTimeout(() => {
                        this.Terms = JSON.parse(JSON.stringify(terms));
                        this.Contract.Terms = JSON.parse(JSON.stringify(terms));
                    }, 50); // Delay to allow animation to start
                }

            },

            getCustomTerms() {

               
                this.$http.request("get", "/api/app/customterm/readlist").then((res) => {

                    console.log("getCustomTerms", res);

                    if (res?.Type == 200) {
                        //this.TermsOptions = [];

                        var defaultTitle = "Default Client Contract Template";
                        //add a default terms.
                        if (this.type == 0) {
                            defaultTitle = "Default Sub-Contractor Contract Template";

                            this.TermsInfo = "Please review the terms of the default Sub-Contractor contract. You may also freely edit or delete any term below to suit your needs.";
                        }
                        //this.TermsOptions.push({ Id: '00000000-0000-0000-0000-000000000000', Tag: defaultTitle, CreatedDate: "", Type: this.type, Terms: this.Terms });

                        this.TermsOptions.push(...res.Data.filter(m => m.Type == this.type));



                        if(this.hasTerms){

                            setTimeout(() => {
                                this.selectedTemplateId = this.TermsId;

                                //console.log("setTimeout", this.selectedTemplateId);
                                //this.updateTerms();
                                //this.updateTerms();
                                this.initData(this.passedInData);
                            }, 100);
                            
                           

                        }else{

                            setTimeout(() => {
                                 this.selectedTemplateId = '00000000-0000-0000-0000-000000000000';
                            }, 100);
                           
                            //this.updateTerms();
                           
                        }

                        //console.log("TermOptions", this.TermsOptions);
                    }
                });
            },

            addTerms() {

                this.nextTermId++;

                this.Terms.push({ id: this.nextTermId, value: "", customTerm: true });

                this.Contract.Terms.push({ id: this.nextTermId, value: "", customTerm: true });

                //console.log("addTerms Contract", this.Contract.Terms);

                //console.log("addTerms", this.Terms);

            },
            getTerms() {

                this.Terms = [];

                this.TermsOptions = [];

                if (this.type == 1) {
                    this.$core.GetClientTerms().then((res) => {

                        console.log("Client Terms", res);
                        if (res?.Type == 200) {
                            for (var i = 0; i < res.Data.length; i++) {


                                this.Terms.push({ id: i + 1, value: res.Data[i].Text, customTerm: false });

                                this.Contract.Terms.push({ id: i + 1, value: res.Data[i].Text, customTerm: false  });

                                if (res.Data[i].Video == null || res.Data[i].Video.length == 0) {
                                    this.VideoUrls.push(res.Data[i].Video);
                                    this.DefaultVideoUrls.push(res.Data[i].Video);
                                } else {
                                    this.VideoUrls.push(fileUrl(res.Data[i].Video));
                                    this.DefaultVideoUrls.push(fileUrl(res.Data[i].Video));
                                }

                                this.nextTermId = i + 1;
                            }

                             var defaultTitle = "Default Client Contract Template";
                            //add a default terms.
                            if (this.type == 0) {
                                defaultTitle = "Default Sub-Contractor Contract Template";

                                this.TermsInfo = "Please review the terms of the default Sub-Contractor contract. You may also freely edit or delete any term below to suit your needs.";
                            }
                            this.TermsOptions.push({ Id: '00000000-0000-0000-0000-000000000000', Tag: defaultTitle, CreatedDate: "", Type: this.type, Terms: this.Terms });

                            //this.Terms = data.Object;
                            //this.Contract.Terms = this.Terms;
                        }

                        //console.log(this.VideoUrls)
                        this.getCustomTerms();

                    });
                } else {
                    this.$core.GetSubcontractorTerms().then((res) => {
                        //console.log("Sub Terms", res);
                        if (res?.Type == 200) {
                            for (var i = 0; i < res.Data.length; i++) {
                                this.Terms.push({ id: i + 1, value: res.Data[i].Text, customTerm: false  });
                                this.Contract.Terms.push({ id: i + 1, value: res.Data[i].Text, customTerm: false  });

                                if (res.Data[i].Video == null || res.Data[i].Video.length == 0) {
                                    this.VideoUrls.push(res.Data[i].Video);
                                    this.DefaultVideoUrls.push(res.Data[i].Video);
                                } else {
                                    this.VideoUrls.push(fileUrl(res.Data[i].Video));
                                    this.DefaultVideoUrls.push(fileUrl(res.Data[i].Video));
                                }

                                this.nextTermId = i + 1;
                            }
                            //this.Terms = data.Object;
                            //this.Contract.Terms = this.Terms;

                             var defaultTitle = "Default Client Contract Template";
                            //add a default terms.
                            if (this.type == 0) {
                                defaultTitle = "Default Sub-Contractor Contract Template";

                                this.TermsInfo = "Please review the terms of the default Sub-Contractor contract. You may also freely edit or delete any term below to suit your needs.";
                            }
                            this.TermsOptions.push({ Id: '00000000-0000-0000-0000-000000000000', Tag: defaultTitle, CreatedDate: "", Type: this.type, Terms: this.Terms });

                        }

                        this.getCustomTerms();

                    });
                }



            },
            triggerFileInput(index) {
                const refName = `attFile${index}`;
                if (this.$refs[refName]) {
                    this.$refs[refName][0].click(); 
                }
            },
            addAttachments() {
                this.Attachments = [];
                this.Attachments.push({ title: '', files: [] }, { title: '', files: [] }, { title: '', files: [] }, { title: '', files: [] } );
                //console.log(`Current Attatchment `, this.Attachments);
            },
            getAttatchmetsData() {
                let data = [];
                this.Attachments.forEach((x, idx) => {
                    if (x.id) {
                        data.push(
                            {
                                id: x.id,
                                title: x.title,
                                file: x.files.map(f => f.fileId).join(',')
                            }
                        );
                    } else {
                        data.push(
                            {
                                title: x.title,
                                file: x.files.map(f => f.fileId).join(',')
                            }
                        );
                    }
                    
                });
                return data;
            },
            handleAttachemtFileUpload(attachmentIndex, event) {
                // This Uploader support multiple files But ...
                this.DropBoxHighlight = false;
                const maxFiles = 1; // LOL
                const maxSizeMB = 5; // MB
                let files = [];
                if (event.dataTransfer) {
                    files = event.dataTransfer.files;
                } else {
                    files = event.target.files;
                }
                
               //console.log(`handleAttachemtFileUpload ====>`, files);

                this.validFiles = Array.from(files).filter(
                    (file) => file.type.startsWith('image/') || file.type === 'application/pdf'
                );

                if (files.length !== this.validFiles.length) {
                    event.target.value = '';
                    this.popupMessage(`Error`, `Please attach only PDF or Image files.`);
                    return;
                }

                // check max files
                if (files.length > maxFiles) {
                    event.target.value = '';
                    this.popupMessage(`Error`, `You can only select ${maxFiles} files，but you slelected ${files.length}.`);
                    return;
                }

                // check file size and upload
                for (let file of files) {
                    if (file.size > maxSizeMB * 1024 * 1024) {
                        event.target.value = '';
                        this.popupMessage(`Error`, `File ${file.name} exceeds ${maxSizeMB}MB file size limit.`);
                        return;
                    }

                    file.fileId = '';
                }

                // For one file only, force clean up
                this.Attachments[attachmentIndex].files.length = 0;

                const _this = this;
                const _len = this.Attachments[attachmentIndex].files.length;
                
                this.Attachments[attachmentIndex].files.push(...files);
                
                for (let n = _len; n < this.Attachments[attachmentIndex].files.length; n++) {
                    let f = this.Attachments[attachmentIndex].files[n];
                    saveAttachment(f, (fileId) => {
                        if (fileId == '' || fileId === undefined || fileId === null) {
                            _this.Attachments[attachmentIndex].files.splice(n, 1);
                        } else {
                            f.fileId = fileId;
                        }
                        
                        setTimeout(() => {   
                            _this.Attachments.push([]);
                            _this.Attachments.splice(_this.Attachments.length-1, 1);
                        }, Math.floor(Math.random() * (1000 - 500 + 1)) + 500);
                    });
                }

            },
            handleAttachemtFileRemove(attachmentIndex, fileIndex) {
                window.event.stopPropagation();

                let aidx = Number.parseInt(attachmentIndex);
                let fidx = Number.parseInt(fileIndex);

                //console.log(`attachmentIndex = ${aidx}, fileIndex = ${fidx}`);
                if (fidx < 0) {
                    this.Attachments[aidx] = { title: '', files: [] };
                } else {
                    this.Attachments[aidx].files.splice(fidx, 1);
                }
            },
            setAttachmentVisble() {
                let idx = this.DisplayAttachmentBox.findIndex(x => x == 0);
                if (-1 < idx) {
                    this.DisplayAttachmentBox[idx] = 1;
                }
            },
            popupMessage(title,msg) {
                this.showPopup = true;
                this.iconColor = 'red';
                this.popupIconSrc = require('@/assets/images/icons/ErrorIcon.png');

                this.popupTitle = `${title}`;
                this.content = `${msg}`;
                this.cancelText = null;
                this.confirmText = 'OK';
                this.confirmButtonType = 'error';
                this.currentConfirmAction = () => {
                    this.showPopup = false;
                };
            },
            onCancel() {
                this.showPopup = false;
            }

        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .toggle-switch {
        display: flex;
        align-items: center;
        background-color: #f5f7f6;
        padding: 0 8px 0 8px;
        border-radius: 2px;
        color: #38a169;
        font-size: 14px;
    }

    input[type="checkbox"] {
        display: none;
    }

    .toggle-indicator {
        color: white;
    }

    .toggle-label {
        width: 40px;
        font-size: 12px;
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        padding: 2px 4px;
        background-color: #ccc; /* Light background color */

        border-radius: 15px;
        position: relative;
        font-weight: bold;
        color: #38a169; /* Green color */
        transition: background-color 0.3s;
    }

        .toggle-label::before {
            content: ' ';
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #e6f9f0; /* Toggle color */
            color: #fff;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            position: absolute;
            left: 2px;
            transition: transform 0.3s;
        }

    input[type="checkbox"]:checked + .toggle-label::before {
        transform: translateX(20px); /* Shift toggle position when checked */
    }

    input[type="checkbox"]:checked + .toggle-label {
        background-color: #38a169; /* Light green background when checked */
    }

    .toggle-text {
        margin-left: 8px; /* Space for the toggle circle */
        font-weight: bold;
    }

    .terms-enter-active, .terms-leave-active {
        transition: all 0.5s ease;
    }

    .terms-enter, .terms-leave-to /* .terms-leave-active in <2.1.8 */ {
        opacity: 0;
        transform: translateY(20px);
    }

    .terms-move {
        transition: transform 0.5s ease;
    }

    .attachment-plus {
        cursor: pointer;
        color: #71b18f;
        font-size: 31px;
        border-radius: 50%;
        margin: 0px;
        padding: 0px;
    }

        .attachment-plus:hover {
            box-shadow: 0px 0px 3px #303030;
        }

        .attachment-box {
            padding: 15px 10px 0px 10px;
            margin: 0px 10px 10px 10px;
            box-shadow: 0px 4px 8px 0px #a0a0a0;
            background: -webkit-linear-gradient(#cde5de, #efefef);
            background: -o-linear-gradient(#cde5de, #efefef);
            background: -moz-linear-gradient(#cde5de, #efefef);
            background: linear-gradient(#cddee5, #efefef);
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-smooth: subpixel-antialiased;
            border-radius: 3px;
        }

    .schedule {
        min-width: 25%;
        padding: 10px 15px;
        margin: 5px 0px 5px 0px;
        border-radius: 5px;
        background-color: #ffffff;
    }

        .schedule .trash {
            position: absolute;
            color: rgb(208, 192, 192);
            font-size: 25px;
            text-align: center;
            bottom: -5px;
            right: -10px;
        }

        .schedule:hover {
            box-shadow: 5px 5px 15px -15px #000;
        }

            .schedule:hover .trash {
                color: #dc3545 !important;
            }

    .schedule-title {
      width:100%;
      margin:5px 0px;
    }

    .schedule-upload-area {
        background-color: #e6f0f2;
        border-radius: 5px;
        text-align: center;
        font-size: 12px;
        cursor: pointer;
        position: relative;
        min-height: 120px;
        margin: 8px 0px 4px 0px;
        display: table;
        width: 100%;
    }

        .schedule-upload-area.DropBoxHighlight {
            background-color: #f0e6e6;
        }

        .schedule-upload-area input[type="file"] {
            display: none;
        }

        .schedule-upload-area .txt {
            font-size: medium;
            display: table-cell;
            vertical-align: middle;
        }

        .schedule-upload-area .icon {
            font-size: 70px;
            color: #7296a4;
            display: table-cell;
            vertical-align: middle;
            padding:0px;
        }

    .schedule-filelist {
        width: 100%;
        position: absolute;
        bottom: 0px;
        padding: 3px 3px;
        left: 0px;
        list-style-type: none;
        margin: auto;
        display:none;
    }

        .schedule-filelist li {
            font-size: 12px;
            position: relative;
            text-align: left;
            cursor: default;
            background-color: rgba(255,207,101,0.5);
        }

        .schedule-filelist li::marker {
           font-size:12px;
           color:#808080;
        }

        /*
        .schedule-filelist li:nth-child(odd) {
            background-color: #ffffff;
        }

        .schedule-filelist li:nth-child(even) {
            background-color: #f0f0f0;
        }
        */

    .schedule-filename {
        width: calc(100% - 80px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block !important;
        vertical-align: bottom;
        font-size: 12px;
        text-align: left;
        padding: 2px 4px;
    }

    .schedule-option {
        font-size: 12px;
        text-align: right;
        position: absolute;
        right: 0px;
        top: auto;
        bottom: 0px;
        width: 75px;
        padding: 1px 0px;
    }

        .schedule-option i {
            font-size: 16px;
            position: relative;
            top: auto;
            bottom: -4px;
            margin: 0px;
            padding: 0px;
            color: #606060 !important;
        }

        .schedule-option i:hover {
            color: #dc3545 !important;
        }

        .image-icon{
            background-image: url('../assets/images/icons/IMAGE_ICON.png');
            background-repeat: no-repeat;
            background-position: center;
        }
        .pdf-icon{
            background-image: url('../assets/images/icons/PDF_ICON.png');
            background-repeat: no-repeat;
            background-position: center;
        }
    
</style>



